export const DATE_DEVIS = {
  header: 'Modification des dates d\'affichages',
  headerAchat: 'Modification de la période',
  button: {
    cancel: 'Annuler',
    validate: 'Terminer',
  },
  date: {
    du: 'Du',
    au: 'au',
    dateDebut: 'Date de debut',
    dateFin: 'Date de fin',
  },
  affectation: {
    commande: 'Commande ',
    reseau: 'Réseau ',
  },
  tab: {
    libelle: 'Libellé',
    prixUnitaire: 'Prix unitaire',
    quantite: 'Quantité',
    montantBrut: 'Montant brut',
  },
  majDateRenouvelement: 'Mettre à jour la date de renouvellement',
  majQuantiteProrataTemporis: 'Mettre à jour la quantité des lignes en fonction des dates sélectionnées',
  nouvelleQuantite: 'Nouvelle quantité :',
  selectionLigne: 'Modifier la quantité sur :',
  pasDate: 'Aucune date n’est sélectionnée',
  deleteTfsAfterDateFin: 'Supprimer les affectations logistiques après cette nouvelle date de fin',
  info: 'Information',
  libelleLink: '{type} {libelle} du {dateDebut} au {dateFin}',
  error: {
    title: 'Erreur(s)',
    debutSuperieurFin: 'La date de début doit être inférieure ou égale à la date de fin.',
    pasDeDebutEtFin: 'Vous devez saisir une date de début et une date de fin.',
    pasDeDebut: 'Vous devez saisir une date de début.',
    pasDeFin: 'Vous devez saisir une date de fin.',
    faceAffecte: 'La face est actuellement affectée sur :',
    reseauAffecte: 'Le réseau est actuellement affecté sur :',
    faceAffecteeLogistiquement: 'Impossible de modifier la date de début car la ligne de commande a déjà une affectation logistique',
    warningAffectationsApresDateFin: 'Attention, il existe des affectations logistiques pour cette ligne de commande après la date de fin saisie',
    produitArchive: 'Le produit face est archivé',
  },
};

export const LISTE_DEVIS = {
  title: 'Liste des devis',
  repertoire: 'Devis',
  racine: 'Accueil',
  status: {
    save: 'Enregistré',
    order: 'Commandé',
    bill: 'Facturée',
    clos: 'Clos',
    partBill: 'Facturée partiellement',
    sansSuite: 'Sans suite',
    commandePartiel: 'Commandé partiellement',
    brouillon: 'Brouillon',
    cree: 'Créé',
    rapproche: 'Rapproché',
    rapprochePartiellement: 'Rapproché partiellement',
    receptionnee: 'Réceptionnée',
    receptionneePartiellement: 'Réceptionnée partiellement',
  },
  actions: {
    filtre: 'Filtre',
    newQuotation: 'Nouveau devis',
    drafts: 'Brouillons',
    sent: 'Envoyés',
    accepted: 'Acceptés',
    search: 'Rechercher',
    sansSuite: 'Sans suite',
    changementCommercial: 'Changement commercial',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    planMedia: 'Plan(s) média',
    produits: 'Produits',
    parutions: 'Parutions',
    typeProduit: 'Type de produit',
    datePremierAffichage: 'Date de campagne',
    dateValidite: 'Date de validité',
    au: 'au',
    client: 'Clients',
    etat: 'Liste des états',
    commercial: 'Commercial',
    referenceClient: 'Référence client',
    tiers: 'Client: {client}',
    referenceDevis: 'Devis: {devis}',
    referenceFacture: 'Facture: {code}',
    agence: 'Agence',
    codeDossier: 'Code dossier',
    theme: 'Thème',
    assistant: 'Assistant',
    sansAssistant: 'Sans assistant',
    noCommercial: 'Sans commercial',
    enseigne: 'Enseigne(s)',
    groupe: 'Groupe(s)',
    estSigne: 'Signé',
    labelEstSigneSurCommande: 'Signée',
    estSigneElectroniquement: 'Signé électoniquement',
    signeElectroniquementSurCommande: 'Signée électoniquement',
    dateDevis: 'Date de devis',
    dateCommande: 'Date de commande',
    reconductible: 'Reconductible tacitement',
    renouvelable: 'Renouvelable',
    estIndexable: 'Indexé',
    indicesIndexation: 'Indice d\'indexation ',
    codeCommande: 'Code commande',
    tags: 'Tags',
    actions: {
      search: 'Rechercher',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
    error: {
      errorDatePremierAffichage: 'La date de fin de la date de campagne est supérieure à la date de début',
      errorDateDevis: 'La date de fin de la date de devis est supérieure à la date de début',
      errorDateCommande: 'La date de fin de la date de commande est supérieure à la date de début',
    },
    departementPayeur: 'Département du payeur',
    secteur: 'Secteur(s)',
  },
  table: {
    code: 'Code',
    status: 'Etat',
    date: 'Date',
    customers: 'Clients',
    amountHt: 'Montant HT',
    commercial: 'Commercial(e)',
    folderCode: 'Code dossier',
    datePremierAffichage: 'Date de campagne',
    typeProduit: 'Type de produit',
    estSigne: 'Signé',
  },
  popUpSansSuiteMess: 'Etes-vous sûr de vouloir classer sans suite ces devis ?',
  popUpSansSuiteMessSuccess: '{numDevis} devis classé(s) sans suite',
};

export const AJOUT_DEVIS = {
  title: 'Ajouter un devis',
  updateTitle: 'Modifier un devis',
  tabs: {
    devis: 'Devis',
    previsualisation: 'Paramétrage édition',
    echeancierFacturation: 'Echéancier de facturation',
    achats: 'Achats',
    logistique: 'Logistique',
    commissions: 'Commissions commercial',
    etatSuiviDevisCommande: 'Suivi administratif',
  },
  popUpProduct: {
    title: 'Les lignes suivantes n\'ont pas de produit. Etes-vous sûr de vouloir sauvegarder ?',
  },
  problemOccurred: 'Un problème est survenu',
  editSettlement: 'Modifier le mode de règlement',
  modeSettlement: 'Mode de règlement',
  periodSettlement: 'Délai de règlement',
  show: 'Consulter',
  toOrderTitle: 'Souhaitez-vous commander le devis n°{code} ?',
  faceNum: 'Faces numériques',
  resNum: 'Réseaux numériques',
  salon: 'Salon',
  sponsoring: 'Sponsoring / Événementiel',
  autre: 'Autre',
  presse: 'Presse',
  reseauMairie: 'Réseaux mairies',
  reseauLc: 'Réseaux Lc',
  ajoutProd: 'Ajouter un {produit}',
  reseauNum: 'réseau numérique',
  reseauTempo: 'Réseau temporaire',
  enseignePrincipale: 'Enseigne principale',
  libelle: 'Libellé',
  panierVide: 'Votre panier est vide',
  enseignesMarques: 'Enseignes / Marques',
  ville: 'Ville',
  departements: 'Département',
  agglomeration: 'Agglomération',
  nbHabitants: 'Nombres d\'habitants',
  superieurA: 'Supérieur à',
  inferieurA: 'Inférieur à',
  egaleA: 'Egale à',
  selectionnerProduit: 'Sélectionnez des produits depuis le planning',
  ecranNum: 'écran numérique',
  panier: 'Panier',
  brief: 'Mon brief',
  total: 'Total',
  budgetMax: 'Budget max',
  au: '{dateDebut} au {dateFin}',
  produitPanier: '{nbProduits} produits dans votre panier',
  appliquerBrief: 'Appliquer les paramètres de votre brief',
  appliquer: 'Appliquer',
  modeDiffusionPlanning: 'Mode de diffusion : {modeDiffusion}',
  saturationLabel: '1 boucle /',
  saturationLabelPanier: ' (1 boucle / {saturation})',
  saturation: 'Saturation',
  datePlanning: 'du {dateDebut} au {dateFin} ',
  reinitialiser: 'Réinitialiser',
  modeDiffusion: 'Mode de diffusion',
  actions: {
    planning: {
      showAll: 'Afficher tout',
      showInitial: 'Affichage initial',
    },
    toOrder: 'Commander',
    show: 'Consulter',
    ajoutDevis: 'Ajouter au devis',
    revert: 'Retour',
    toOrderConfirme: 'Commander ce devis',
    addClient: 'Créer un client',
    advancedSearch: 'Recherche avancée',
    add: 'Ajouter',
    addLine: 'Ajouter une ligne',
    addSubTotal: 'Ajouter un sous total',
    addComment: 'Ajouter une ligne de texte',
    addFace: 'Face unitaire',
    addNetwork: 'Ajouter un réseau',
    addProduct: 'Ajouter un produit',
    addRemise: 'Ajouter une remise',
    end: 'Terminer',
    edit: 'Modifier',
    groupedActionPlaceholder: 'Actions groupées',
    groupedActionGroup: 'Créer un groupe de produit',
    remisePrixNetFace: 'Obtenir un prix net par face',
    informationRegroupement: 'Information sur le regroupement',
    groupedActionMajPu: 'Modifier le prix unitaire',
    groupedActionMajTva: 'Modifier la TVA',
    modifierEtatSouhaite: 'Modifier l\'état souhaité',
    groupedActionApply: 'Appliquer',
    groupedActionMasseDelete: 'Supprimer',
    duplication: 'Dupliquer',
    groupedActionMajRemisePerso: 'Faire une remise',
    modifierDates: 'Modifier les dates de début et de fin',
  },
  errors: {
    deuxDates: 'Vous ne pouvez pas renseigner une seule date',
    produitLoc: 'Le mode de diffusion est obligatoire',
    dateFin: 'La date de fin doit être supérieure à la date de début',
  },
  generalTitle: {
    generalInformations: 'Informations générales',
    clientsSelect: 'Sélection des clients',
    articles: 'Articles',
  },
  informations: {
    commercialName: 'Nom commercial',
    postalAddress: 'Adresse postale',
    address: 'Adresse',
    addClient: 'Ajouter un client',
    quotationDate: 'Date du devis',
    validityDate: 'Date de validité',
    dates: 'Dates d\'affichage',
    trade: 'Commercial(e)',
    agence: 'Agence',
    theme: 'Thème / Objet',
    assistant: 'Assistant(e)',
    customerReference: 'Référence client',
    role: 'Rôle',
    product: 'Produit',
    rate: 'Tarif',
    wording: 'Libellé',
    datePremierAffichage: 'Date de campagne',
    categorieVente: 'Type de produit',
    quantity: 'Qté',
    unitaryCost: 'P.U.',
    discount: 'Remise',
    percentageTva: '% TVA',
    totalHt: 'Total HT',
    totalHtDiscount: 'Total HT remisé',
    quotationCommentary: 'Commentaires devis',
    internCommentary: 'Commentaires internes',
    adresseLivraison: 'Adresse de livraison',
    totalTtc: 'Total TTC',
    totalTva: 'T.V.A.',
    displayDate: 'Dates d\'affichage',
    from: 'Du',
    aucunCommercial: 'Aucun(e) commercial(e) sélectionné(e)',
    aucunAssistant: 'Aucun(e) assistant(e) sélectionné(e)',
    to: 'Au',
    occupationPercentage: 'Pourcentage d\'occupation',
    subTotalHt: 'Sous-total HT',
    dontHaveSettlementPeriod: 'Le délai de règlement n\'est pas renseigné',
    dontHaveSettlementMode: 'Le mode de règlement n\'est pas renseigné',
    addText: 'Insérer votre texte',
    penalty: 'En cas de retard de paiement, application d\'intérêts de 3 fois le taux légal selon la loi n°2008-776 du 4 août 2008.',
    penaltyLabel: 'Taux de pénalité',
    recovery: 'En cas de retard de paiement, application d’une indemnité forfaitaire pour frais de recouvrement de 40€ selon l\'article D. 441-5 du code du commerce.',
    recoveryLabel: 'Frais de recouvrement',
    discountRate: 'Pas d’escompte applicable.',
    discountRateLabel: 'Taux d\'escompte',
    folderCode: 'Code dossier',
    compteComptable: 'Compte comptable',
    estSigne: 'Signé',
    campagne: 'Campagne',
  },
  table: {
    customer: 'Client',
    settlement: 'Règlement',
    contact: 'Contact',
    address: 'Adresse commerciale',
    percentageOfBilling: 'Quote-part facturation',
    advertiser: 'Annonceur',
    advertiserInitiale: 'Ann.',
    mandatary: 'Mandataire',
    mandataryInitiale: 'Mand.',
    originator: 'Donneur d\'ordre',
    originatorInitiale: 'D.O.',
    payer: 'Payeur',
    payerInitiale: 'Pay.',
    newCustomer: 'Nouveau client',
    newCustomerInitiale: 'Nouv.',
    editionIntervenant: {
      title: 'Modification de l\'intervenant',
      titreIntervenant: 'Titre de l\'intervenant',
      adressePostal: 'Adresse postale',
      adresse: 'Adresse',
      cancel: 'Annuler',
      add: 'Ajouter',
      miseAjourFicheClient: 'Mise à jour de la fiche client',
      applicationTva: 'Application TVA',
      prospect: 'Prospect',
      nomCommercial: 'Nom commercial',
      siret: 'Siret',
      tvaIntracommunautaire: 'Tva intracommunautaire',
    },
    editionContacts: {
      title: 'Gestion des contacts',
      tab: {
        contact: 'Contact',
        types: 'Types',
      },
      addContact: 'Ajouter un contact',
      error: {
        emptyline: 'La ligne {num} ne possède pas de contact',
      },
      addContactToClient: 'Ajouter un contact au client',
      aucunContact: 'Aucun contact',
    },
    advancedSearchContact: {
      title: 'Recherche avancée de clients',
    },
  },
  messages: {
    successCreation: 'Création du devis réalisée avec succès.',
    errorCreation: 'Enregistrement du client impossible. Les champs suivants doivent être renseignés : ',
    editQuotationSuccess: 'Modification du devis réalisée avec succès.',
    successCustomerCreation: 'Création du client réalisée avec succès.',
    aucuneDate: 'Aucune date sélectionnée dans le brief',
  },
  clients: {
    searchClient: 'Ajouter un client',
    addFullCustomer: 'Créer un client complet',
    clientExonerationTva: 'Client exonéré de TVA',
    prospect: 'Prospect',
  },
  ligne: {
    singleDay: 'jour',
    multiDays: 'jours',
    dateFrom: 'Du',
    dateTo: 'Au',
  },
  copieDcf: {
    fieldLabel: 'Copie des produits depuis commande / facture',
    annonceur: 'Annonceur(s): ',
    payeur: 'Payeur(s): ',
  },
  popUpSelectFace: {
    title: 'Sélectionner vos faces : {reseau}',
    nbFacesDispo: '{totalSelect} selectionnées sur {total} faces',
    faceIndispoLogistique: 'Attention, certaines faces sélectionnées ne sont plus disponibles',
    faceIndispoOptionBlocage: 'Liste des faces sélectionnées en option mais non disponibles en blocage',
    actions: {
      cancel: 'Annuler',
      select: 'Sélectionner',
      ajouterIntructionPose: 'Ajouter une instruction de pose',
    },
    tab: {
      dispo: 'Dispo',
      panneau: 'Panneau',
      face: 'Face',
      format: 'Format',
      adresse: 'Adresse',
      ville: 'Ville',
      ReseauFaceTags: 'Sous réseau',
      restriction: 'Restriction',
      logistique: 'Logistique',
      codePostal: 'CP',
      materielType: 'Matériel',
      instructionPose: 'Instruction de pose',
      disposition: 'Disposition',
      formatAffiche: 'Format d\'affiche',
    },
    indispo: {
      inactif: 'La face est inactive',
      dejaPris: 'La face est déjà affectée sur le visuel "{visuel}"',
      libre: 'La face n\'a pas été affectée mais elle est disponible',
      sansPatrimoine: 'Ce produit n\'a pas de face associée dans le patrimoine',
    },
    dispo: 'Disponible',
    nonDispo: 'Non disponible',
    affecte: 'Affecté',
    nonAffecte: 'Non affecté',
    select: 'Sélectionnées',
    nonSelect: 'Non sélectionnées',
    messageInstructionPose: 'Veuillez saisir une instruction de pose',
    faceNonCom: 'La face est non commercialisable',
    countFilteredFace: ' résultats ont été retrouvés',
    countFilteredFaceNotFound: 'Aucun résultat',
    messageIndispo: {
      commande: 'la commande',
      devis: 'le devis',
      parCommercial: 'par {commercial}',
      faceDansVenteTempos: 'La face {face} est indisponible car elle est vendue sur {dcfType} {dcfCode} avec le réseau {reseau} {commercial} à {annonceur}',
      faceArchive: 'La face {face} est indisponible car elle est archivée',
      faceVenteLC: 'La face {face} est indisponible car elle est vendue du {dateDebut} au {dateFin} sur {dcfType} {dcfCode} {commercial} à {annonceur}',
      faceAffecteLogistiquement: 'La face {face} a été affecté logistiquement. {reseauDcfLibelle}',
      faceIndisponible: 'La face {face} est marquée indisponible dans le catalogue',
      faceSelectionAucuneVente: 'Un problème est survenu contacter le support',
    },
  },
  popUpLigneWithoutProduct: {
    quantite: '\tQuantité: {quantite}',
    prix: ' - Prix: {prix} ',
    total: ' - Total: {total} ',
    week: ' S{semaine} {annee} ',
    dates: ' du {debut} au {fin}',
  },
  partial: {
    produitCommande: 'Produit commandé :',
  },
  popUpDuplicationLigne: {
    title: 'Dupliquer les lignes',
    qteACreer: 'Quantité',
    warningSelection: 'Votre sélection a été appliquée',
  },
  etatSuivi: {
    dateTransmissionAuClub: 'Date de transmission au club',
    transmissionAuClub: 'Transmis au club',
    dateTransmissionAuClient: 'Date de transmission au client',
    transmissionAuClient: 'Transmis au client',
    etatsDeSuivi: 'Etats de suivi',
    ajouterEtat: 'Ajouter un état',
    etatDeSuivi: 'Etat de suivi',
    date: 'Date',
  },
  openLigne: 'Déplier toutes les lignes',
  hideLigne: 'Replier toutes les lignes',
};

export const VALIDATION = {
  anneeSemaineRequired: 'Vous devez sélectionner une semaine pour chaque produit réseau',
  qteFacesSouhaiteesInf: 'Le nombre de faces souhaitées doit être supérieur à 0.',
  notProposableLc: 'La face {ref} n\'est pas proposable en vente LC',
  sansSuiteForbiddenWithOrder: 'Impossible de classer ce devis sans suite car un ou des acomptes sont rattachés à ce devis',
  faceDateOverlap: 'Impossible de vendre la même face dans la même commande avec des dates se chevauchant',
  leastOneCustomer: 'Vous devez sélectionner au moins un client par devis.',
  fusionEcheancierVenteInterne: 'Si vous vendez un produit d\'une autre société, vous ne pouvez pas avoir un échéancier regroupé',
  needDiscount: 'Vous devez renseigner la remise',
  normalLine: 'Une ligne de devis est nécessaire entre 2 lignes de remises',
  leastOneAdvertiser: 'Vous devez indiquer au moins un annonceur par devis.',
  leastOnePayer: 'Vous devez indiquer au minimum un payeur par devis.',
  pourcentageDivision: 'La somme des pourcentages de facturation des payeurs doit être égale à 100%.',
  amountDivision: 'La somme des quotes-parts de facturation doit être égale au montant total du devis.',
  proxyNotRepresentative: 'Un client ne peut être annonceur et mandataire sur un même devis.',
  unitPriseLessZero: 'Le prix unitaire des produits doit être supérieur à 0.',
  quantityLessZero: 'La quantité des produits doit être supérieure à 0.',
  sameProduct: 'Impossible d\'ajouter le même produit à la même date',
  discountBetween0100: 'La remise de la ligne en pourcentage doit être entre 0 et 100',
  discountBetween0Amount: 'La remise de la ligne en montant doit être entre 0 et le montant de celle-ci',
  leastOneProduct: 'Vous devez saisir au minimum un produit dans le devis.',
  notSameDivisionType: 'Les quotes-parts des payeurs doivent être du même type.',
  saveImpossible: 'Enregistrement du devis impossible.',
  editImpossible: 'Modification du devis impossible.',
  quotationNotfound: 'Le devis n\'a pas été trouvé.',
  notSaveState: 'L\'état du devis doit être "enregistré".',
  agenceId: 'Vous devez sélectionner une agence.',
  notQuotation: 'La commande ne peut être créée qu\'à partir d\'un devis.',
  notOrder: 'Aucune commande n\'a été générée.',
  sumMontantAcompteGreat: 'La somme des montants des acomptes dépasse le montant total du devis.',
  acompteMultipayeurForbidden: 'Le multipayeur est impossible avec des devis ayant des acomptes.',
  ShoudContainsLocationOrBillBoard: 'La vente doit contenir au moins une ligne',
  TotalHtLowerThanDiscountLine: 'La remise dépasse le montant de la vente',
  etatObtenu: 'Au moins une ligne de vente contient un état obtenu à "{etatObtenu}"',
  waitForOrder: 'Au moins une ligne de vente est en attente de validation',
  faceNotAvailable: 'Une des faces sélectionnées dans un réseau n\'est pas disponible',
  faceNotAvailableInSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine}',
  sameFaceInSameWeek: 'La même face ne peut pas être sélectionnée à la même période sur différents réseaux',
  faceSelectGreaterThanFaceWish: 'Le nombre de faces sélectionnées est plus grand que le nombre de faces souhaitées',
  lineMustBeBloque: 'Pour sélectionner des faces, l\'état d\'option et blocage de la ligne doit être à "bloqué"',
  devisCommandeNotCancel: 'Le devis ou la command ne doit pas être annulé',
  newCommandeLigneAtEnd: 'Les nouvelles lignes de vente ajouté à un devis partiellement commandé doivent être à la fin du devis',
  onlyOnePayeur: 'Impossible d\'avoir plusieurs payeur si le role est différent de \'Régie\'',
  noRegroupementPerso: 'Impossible d\'avoir un regroupement personalisé si le le role est différent de \'Régie\'',
  echeancierManuelShouldHaveEcheancierLignes: 'Un échéancier manuel doit avoir des lignes d\'échéanciers',
  googleMapKeyInvalid: 'La clef API google est invalide',
  etatDemandeShouldBeTrue: 'L\'état de la demande doit être correctement envoyé',
  sameBillingType: 'Les lignes de commande de l\'échéancier doivent avoir le même type de facturation',
  noMoreOneHundred: 'Le total des commissions ne doit pas faire plus que 100%',
  parutionNeeded: 'La parution est obligatoire pour le produit: {produit}',
  sameSupplier: 'Les lignes de commande de l\'échéancier doivent avoir le même fournisseur',
  cantOrderWithProspec: 'Impossible de commander un devis avec un intervenant prospec',
  lockedClient: 'L\'intervenant {nomCommercial} est Totalement bloqué',
  remiseInterditeCompta: 'Interdit d\'ajouter une ligne de remise',
  savedStateRRequired: 'Le devis doit être à l\'état "enregistré"',
  savedStateRRequiredWithCode: 'Le devis {code} doit être à l\'état "enregistré"',
  sansSuiteForbiddenWithOrderWithCode: 'Impossible de classer le devis {code} sans suite car un ou des acomptes sont rattachés à ce devis',
  wrongSigneEcheancier: 'Problème de signe sur les échéances',
  name: {
    role: 'Rôle',
    libelleLigneCommande: 'Libellé de la ligne',
    quantiteLigneCommande: 'Quantité de la ligne',
    prixUnitaireLigneCommande: 'Prix unitaire de la ligne',
    remiseLigneCommande: 'Remise de la ligne',
    tauxTvaLigneCommande: 'Taux de Tva de la ligne',
    dateDevisCommande: 'La date de devis',
    dateValidite: 'Date de validité',
    repartitionIntervenant: 'Quote-part facturation',
    tauxPenalite: 'Taux de pénalité',
    tauxEscompte: 'Taux d\'escompte',
    remise: 'Remise',
    numStand: 'N° stand',
    nomDispositif: 'Nom du dispositif',
    materielTypeId: 'Type de matériel',
    dispositifTypeId: 'Type de dispositif',
    materielFormatId: 'Format',
  },
  annonceurWithSameExonerationTva: 'Tous les annonceurs doivent être éxonérés de TVA',
  ligneCommandeWithZeroTva: 'Si un annonceur est exonéré de TVA, les lignes de ventes doivent avoir un taux de TVA à 0',
  partial: {
    alreadyOrdered: 'Une ligne de commande est déjà commandée',
    insideBundle: 'Une ligne de commande est dans un regroupement',
    insideCustomBundle: 'Une ligne de commande est dans un réseau personnalisé',
    notQuotation: 'Une ligne de commande n\'existe pas dans le devis',
    lineWrongType: 'Les lignes de commande doivent être de type regroupement, personnalisé ou normal. Mais une ligne était de type "{typeLigne}"',
    etatSuiviId: 'L\'état de suivi dans les lignes de suivi administratif',
  },
  productPurchase: 'Le produit {libelle} doit avoir un produit opposé de sens achat',
  ligneCommandeWithoutLigneLocation: 'La vente du réseau {reseau} doit avoir une ligne location',
  remiseRegieshouldBeLast: 'La remise régie de la ligne {libelle} du produit {produit} doit être la dernière',
  remiseRegieOnlyOne: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle} du produit {produit}',
  remiseRegieMustBePreceded: 'La remise régie de la ligne {libelle} du produit {produit} doit être précédée d\'une ligne sous total',
  remiseRegieshouldBeLastWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être la dernière',
  remiseRegieOnlyOneWithoutRegroupement: 'On ne doit avoir qu\'une seule remise régie pour la ligne {libelle}',
  remiseRegieMustBePrecededWithoutRegroupement: 'La remise régie de la ligne {libelle} doit être précédée d\'une ligne sous total',
  negativeNormalCommandLineForbidden: 'Il est interdit d\'avoir une ligne de commande négative',
  negativeNormalCommandForbidden: 'Il est interdit d\'avoir un devis négatif',
  SansSuiteForbiddenMoveWithCode: 'Impossible de classer le devis {code} sans suite car il a une signature dont l\'état de la demande est "envoyée" ou "signée".',
  SansSuiteForbiddenMove: 'Impossible de classer le devis sans suite car il a une signature dont l\'état de la demande est "envoyée" ou "signée".',
  dateFinEcheancierLigneNotBeLessThanDateDebut: 'La date de fin de la ligne d\'écheance pour du produit "{libelle}" ne peut être antérieure à sa date de début ({dateDebut}).',
  dateFinEcheancierLigneNotBeLessThanDateDebutMulti: 'La date de fin de la ligne d\'écheance ne peut être antérieure à sa date de début ({dateDebut}) pour les produits suivants : \n{libelle}',
  ligneCmdSelOptionProduitHasPartialSelection: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}',
  ligneCmdSelOptionProduitHasTfs: 'La face {face} n\'est pas disponible à la sélection pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}',
  ligneCmdSelOptionProduitOneNotExist: 'L\'une des faces sélectionnés sur la ligne {ligne} n\'existe pas ou est inactif',
  ligneCmdSelOptionProduitSelectedOnce: 'La face {face}, sélectionné pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}, ne peut être sélectionnée qu\'une seule fois',
  ligneCmdSelOptionProduitIsInactive: 'La face {face}, sélectionné pour le réseau {reseau} à la semaine {semaine} de l\'année {annee}, est actuellement inactive',
  ligneCmdSelOptionProduitsInDevis: 'La sélection de face en demande d\'option ne peut être faite que sur des lignes de devis',
  ligneCmdSelOptionProduitsInDevisVente: 'La sélection de face en demande d\'option ne peut être faite que sur une vente',
  ligneCmdSelOptionProduitsInVenteTempos: 'La sélection de face en demande d\'option ne peut être faite que sur une vente temporaire',
  suppProduitRegroupementInDevisWithValidationModifBlocage: 'Impossible de supprimer une ligne de vente réseau avec un état obtenu "Bloqué". Veuillez passer par un changement d\'état.',
  SansSuiteForbiddenMoveWithValidationBlocage: 'Impossible de classer le devis sans suite car il a une ligne de vente réseau avec un état obtenu "Bloqué". Veuillez passer par un changement d\'état.',
};

export const SUPPRESSION = {
  irreversible: 'La suppression du devis est irréversible.',
  delete: 'Etes-vous sûr de vouloir supprimer ce devis ?',
  irreversibleMultiple: 'La suppression des devis irréversible.',
  deleteMultiple: 'Etes-vous sûr de vouloir supprimer ces devis ?',
  yes: 'Oui',
  no: 'Non',
  messages: {
    errorTitle: 'Suppression du devis impossible.',
    errorTitleMultiple: 'Suppression des devis impossible.',
    error: 'Veuillez réessayer ou contacter le service client.',
    success: 'Suppression du devis réalisée avec succès.',
    successMultiple: 'Suppression des devis réalisée avec succès.',
  },
  apiMessages: {
    DELETE_QUOTATION_HAVE_ORDER: 'le devis {param1} est associé à la commande {param2}',
  },
  SansSuiteForbiddenMoveWithValidationBlocage: 'Impossible de supprimer le devis car il a une ligne de vente réseau avec un état obtenu "Bloqué". Veuillez passer par un changement d\'état.',
};

export const DETAIL_DEVIS = {
  typeDevis: 'Devis',
  tabs: {
    detail: 'Détail',
    achats: 'Achats',
    previsualisation: 'Paramétrage édition',
    logistique: 'Logistique',
    commissions: 'Commissions commercial',
    echeancierFacturation: 'Echéancier de facturation',
    etatSuiviDevisCommande: 'Suivi administratif',
    signatureElectroniqueHisto: 'Signature',
  },
  steps: {
    echeancierFacturation: 'Echéancier de facturation',
  },
  actions: {
    commandePartiellement: 'Commander partiellement',
  },
  popUpMail: {
    title: 'Rédiger votre email',
    inclureDevis: 'Inclure le devis',
    devisObject: 'Devis {code} du {date}',
    contactTitle: 'Contacts devis',
  },
  dupliquer: {
    title: 'Dupliquer le devis n°{code}',
  },
  etat: 'Etat : ',
  popupDuplicate: {
    title: 'Réseau: {reseau}',
    nbFace: 'Nombre de faces: {nbFace}',
    tab: {
      libelle: 'Libelle',
      anneeSemaine: 'Semaine',
      dateDebut: 'Date debut',
      dateFin: 'Date fin',
      qteFacesPrevues: 'Faces du réseau',
      qteFacesSouhaitees: 'Faces souhaitées',
      facesSelectionneees: 'Faces séléctionnées',
    },
  },
  popUpSelectFace: {
    title: 'Faces sélectionnées : {reseau}',
    actions: {
      back: 'Retour',
    },
    dateJour: 'Le {dateDebut}',
    datePeriode: 'Du {dateDebut} au {dateFin}',
    dateSemaine: 'S{semaine} - du {dateDebut} au {dateFin}',
  },
  echeanciers: {
    title: 'Echéancier de facturation',
  },
  commandePartiel: {
    title: 'Commander partiellement',
    produitCommander: 'Produit commandé',
    actions: {
      commander: 'Commander',
    },
    gestionCommande: 'Comment souhaitez-vous générer votre commande ?',
    filtre: {
      periode: 'Filtrer par période',
      typeProduit: 'Filtrer par type de produit',
    },
    select: 'Sélectionné :',
    tab: {
      produit: 'Produit',
      montant: 'Montant',
      produitDetail: {
        dateUnJour: '{dateDebut} au {dateFin} - {jours} jour',
        dateMultiJour: '{dateDebut} au {dateFin} - {jours} jours',
        jourDepart: ' - {nbFace} face(s) - Départ {jourDepart} {date}',
      },
    },
    generation: {
      title: 'Comment souhaitez-vous générer votre commande ?',
      type: {
        aucun: 'En une seule commande',
        typeProduit: 'En une commande par typologie de vente',
        patrimoine: 'En une commande par patrimoine',
      },
      typeProduit: {
        reseauPerso: 'Réseau personnalisé',
      },
    },
  },
  messages: {
    succes: 'Les commandes ont été créées avec succès.',
    demandeSignatureSucces: 'La demande de signature a été envoyée avec succès.',
    closeDemandeSignatureSucces: 'La demande de signature a été stoppée avec succès.',
  },
  signature: {
    title: 'Signatures',
    tab: {
      dateEnvoie: 'Date d\'envoi',
      contratEtatSignature: 'Etat de la demande',
      envoyeur: 'Demandeur',
      dateSignature: 'Date de signature',
      contact: 'Contact',
      tiers: 'Tiers',
    },
    contratEtatSignature: {
      openned: 'Envoyée',
      signed: 'Signée',
      archived: 'Signée',
      canceled: 'Annulée',
      closed: 'Close',
    },
  },
  stopSignature: 'Stopper l\'action de signature',
  infoButtonDesactiver: 'Impossible de modifier le devis car il a une signature dont l\'état de la demande est "envoyée" ou "signée".',
  infoButtonDesactiverCommande: 'Impossible de commander le devis car il a une signature dont l\'état de la demande est "envoyée".',
  infoButtonDesactiverCommandeCarPropect: 'Impossible de commander le devis car il y a un intervenant qui est à l\'état de "prospect".',
};
